export default class WapiForecastParameterViewModel {
  constructor() {
    this.level_type = '';
    this.level = '';
    this.pname = '';
    this.sname = '';
    this.unit = '';
    this.code = '';
    this.checked = false;
  }

  map(wapiForecastParameter) {
    this.level_type = wapiForecastParameter.level_type;
    this.level = wapiForecastParameter.level;
    this.pname = wapiForecastParameter.pname;
    this.sname = wapiForecastParameter.sname;
    this.unit = wapiForecastParameter.unit;
    this.code = wapiForecastParameter.code;

    return this;
  }
}
